import { SvgIcon } from "@material-ui/core";
import React from "react";
import { LIGHT_GREY } from "../config/colors";

const FilterIcon = props => (
  <SvgIcon style={props.style}>
    <g id="Icon/FilterIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox={props.viewBox}
      >
        <g
          stroke={props.color || LIGHT_GREY}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.6"
          clipPath="url(#FilterIcon)"
        >
          <path d="M2.5 19.375v-7.5M2.5 8.125v-7.5M17.5 19.375V8.125M17.5 4.375V.625M10 19.375v-3.75M10 11.875V.625M10 15.625a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75zM17.5 8.125a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75zM2.5 11.875a1.875 1.875 0 100-3.75 1.875 1.875 0 000 3.75z" ></path>
        </g>
        <defs>
          <clipPath id="FilterIcon">
            <path fill="#FFF" d="M0 0H20V20H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </g>
  </SvgIcon>
);

export default FilterIcon;



// WEBPACK FOOTER //
// ./src/icons/FilterIcon.jsx